/* eslint-disable react/jsx-indent */
import { first, isEmpty, get } from "lodash";
import moment from "moment";
import {
  MDBBtn,
  MDBNav,
  MDBNavItem,
  MDBSpinner,
  MDBTabContent,
  MDBTabPane
} from "mdbreact";
import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { openToast } from "~/components/common/molecules/ToastNotification";
import MedicalBillPrinter from "~/components/desktop/molecules/MedicalBillPrinter";
import MedicalCoupon from "~/components/desktop/molecules/MedicalCoupon";
import ModalSendBooking from "~/components/desktop/pages/CustomerService/components/ModalSendBooking";
import ModalCare247Pay from "~/components/desktop/pages/CustomerService/components/ModalCare247Pay";
import history from "~/history";
import {
  getConfirmAssistedPaymentCskh,
  requestPaymentInfoCSKH,
  getCare247Services,
  getCare247IndependentCSKH,
  getCare247IndependentCSKHReset,
  checkVoucherCare247,
  checkVoucherCare247Reset
} from "~/store/customerService/customerServiceActions";
import { redirectToMedproId } from "~/store/login/actions";
import {
  checkRepayment,
  getBookingInfo,
  setPaymentInfomationByCSKH
} from "~/store/totalData/actions";
import {
  selectedPatientDetail,
  selectPatientFromData
} from "~/store/patient/patientAction";
import styles from "./style.module.scss";
import MedicalCouponCare from "~/components/desktop/molecules/MedicalCouponCare";
import cx from "classnames";
import ModalConfirmCashierBooking from "~/components/desktop/pages/CustomerService/components/ModalConfirmCashierBooking";
import { client } from "~/utils/medproSDK";
import {
  getPatientDetail,
  resetPatientForm
} from "~/store/patientForm/patientFormAction";

const isCashierBooking = bookingInfo => {
  return !!bookingInfo?.isCashierBooking && !bookingInfo.confirmCashierBooking;
};

class MedicalBillPrintForCSKH extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSendBookingModal: false,
      selectingBill: null,
      billPrint: this.props.location?.state?.printState,
      loading: false,
      activeItemBooking: "NormalMedpro",
      isConfirmCashierBooking: false,
      confirmCashierBookingLoading: false,
      confirmCashierBookingData: null,
      modalCare247Pay: false,
      loadingCare247Pay: false
    };
    this.printGate = null;
  }

  handleChangeBill = () => {
    if (history.location.pathname === "/user/booking") {
      history.goBack();
    }
    this.setState(v => ({
      loading: !v.loading
    }));
    setTimeout(() => {
      this.setState(v => ({
        billPrint: !v.billPrint,
        loading: false
      }));
    }, 1000);
  };

  createPrintAbortError = () => {
    const error = new Error("Chưa xác nhận thu tiền mặt");
    error.isPrintAborted = true;
    return error;
  };

  settlePrintGate = isConfirmed => {
    const gate = this.printGate;
    if (!gate) return;
    this.printGate = null;
    if (isConfirmed) {
      gate.resolve();
    } else {
      gate.reject(this.createPrintAbortError());
    }
  };

  /* Phiếu thu tiền mặt chưa xác nhận: treo lệnh in cho tới khi xác nhận xong */
  handleBeforePrint = () => {
    const bookingInfo = get(
      first(this.props.paymentInformation),
      "bookingInfo"
    );
    if (!isCashierBooking(bookingInfo)) return;
    if (this.state.confirmCashierBookingLoading) {
      return Promise.reject(this.createPrintAbortError());
    }
    return new Promise((resolve, reject) => {
      this.settlePrintGate(false);
      this.printGate = { resolve, reject };
      /* Tạm thời: tạo phiếu thu lỗi (đã có toast) vẫn cho in, không chặn bởi lỗi BE */
      this.onCreateCashierBooking(bookingInfo).then(isModalOpened => {
        if (!isModalOpened) this.settlePrintGate(true);
      });
    });
  };

  handleCancelCashierModal = () => {
    this.settlePrintGate(false);
    this.toggleModalConfirmCashierBooking();
  };

  componentDidMount() {
    const { paymentInformation } = this.props;
    const { mpTransaction, transactions } = queryString.parse(
      this.props.location.search
    );

    if (!history.location.pathname.includes("/in-phieu-kham-cskh")) {
      this.setState({
        billPrint: this.props.location?.state?.printState || false
      });
    }

    this.loadBookingData(transactions, mpTransaction);

    if (
      this.state.billPrint &&
      history.location.pathname.includes("/user/booking")
    ) {
      this.usePrintRef.handleClick();
    }

    const bookingInfo = first(paymentInformation);

    console.log("bookingInfo?.patient", bookingInfo?.patient);
    //  /cskh/booking?mpTransaction=TT251021N3NFQESDZGK1

    // Listen for focus events to refresh data when returning to page
    window.addEventListener("focus", this.handleWindowFocus);

    // Listen for popstate (browser back/forward) to refresh data
    window.addEventListener("popstate", this.handlePopState);
  }

  componentWillUnmount() {
    // Clean up event listeners
    window.removeEventListener("focus", this.handleWindowFocus);
    window.removeEventListener("popstate", this.handlePopState);

    // Clean up sessionStorage
    sessionStorage.removeItem("isUpdatingPatient");
  }

  handleWindowFocus = () => {
    // Check if we're coming back from patient update page
    const wasUpdatingPatient = sessionStorage.getItem("isUpdatingPatient");
    if (wasUpdatingPatient) {
      sessionStorage.removeItem("isUpdatingPatient");
      this.refreshBookingData();
    }
  };

  loadBookingData = (transactions, mpTransaction) => {
    if (transactions) {
      this.props.getBookingInfo({ transactionId: transactions });
    }
    if (mpTransaction) {
      this.props.requestPaymentInfoCSKH({ transactionId: mpTransaction });
    }
  };

  refreshBookingData = () => {
    const { mpTransaction, transactions } = queryString.parse(
      this.props.location.search
    );
    setTimeout(() => {
      this.loadBookingData(transactions, mpTransaction);
    }, 500);
  };

  handleManualRefresh = () => {
    this.refreshBookingData();
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.paymentInformation &&
      this.props.paymentInformation !== prevProps.paymentInformation
    ) {
      if (
        !!this.props.paymentInformation ||
        !!this.props.paymentInformation.length
      ) {
        this.checkConstraintInfo(first(this.props.paymentInformation));
      }
    }
  }

  checkConstraintInfo = bookingInfo => {
    const returnUrl = window.location.pathname + window.location.search;
    if (bookingInfo?.patient?.constraintInfo?.isValid === false) {
      openToast(
        "Hồ sơ của phiếu khám thiếu thông tin, Vui lòng bổ sung để hoàn tất !",
        "error"
      );
      /* Xử lý call api  */
      this.props.resetPatientForm();
      this.props.handleSelectedPatient({
        ...bookingInfo?.patient,
        patientId: bookingInfo?.patientId
      });
      /* handleGetPatientDetail - Call API to get patient details */
      this.props.handleGetPatientDetail(
        bookingInfo?.patientId,
        bookingInfo?.patient?.secretKey,
        () => {
          history.push("/cskh/booking/cap-nhat-ho-so-benh-nhan", {
            patientId: bookingInfo?.patientId,
            patient: bookingInfo?.patient,
            constraintInfo: bookingInfo?.patient?.constraintInfo,
            returnUrl: returnUrl,
            bookingId: bookingInfo?.id || bookingInfo?.bookingId
          });
        }
      );
    }
    // const { paymentInformation, selectedBill } = this.props;

    // if (!paymentInformation || !paymentInformation.length) return;

    // const firstBooking = first(paymentInformation);
    // const constraintInfo = get(firstBooking, "patient.constraintInfo");

    // if (
    //   constraintInfo &&
    //   !constraintInfo.isValid &&
    //   constraintInfo.errors?.length > 0
    // ) {
    //   // Redirect to patient profile update page
    //   const bookingInfo = get(firstBooking, "bookingInfo");
    //   const patientId =
    //     get(bookingInfo, "patientId") || get(firstBooking, "patientId");
    //   const partnerId = get(bookingInfo, "partnerId") || this.props.partnerId;

    //   if (patientId && partnerId) {
    //     const patientData = firstBooking?.patient;
    //     if (patientData) {
    //       this.props.selectPatientFromData(patientData);
    //     }
    //   }
    // }
  };

  UNSAFE_componentWillMount() {
    if (history.location.pathname.includes("/in-phieu-kham-cskh")) {
      this.setState(v => ({
        billPrint: true,
        loading: false
      }));
    }
    this.setState({
      isConfirmCashierBooking: false,
      confirmCashierBookingLoading: false,
      confirmCashierBookingData: null
    });
  }

  toggleModalSendBooking = billInfo => {
    this.setState({
      showSendBookingModal: !this.state.showSendBookingModal,
      selectingBill: billInfo
    });
  };

  toggleTabs = value => {
    this.setState({ activeItemBooking: value });
  };

  toggleModalConfirmCashierBooking = () => {
    this.setState({
      isConfirmCashierBooking: !this.state.isConfirmCashierBooking
    });
  };

  fetchConfirmAssistedPayment = async () => {
    const { confirmCashierBookingData } = this.state;
    /* Tạm thời: confirm-cashier-booking và lệnh in là 2 nhánh độc lập.
       Chỉ cần CSKH bấm xác nhận là cho in, không đợi/không quan tâm kết quả
       API confirm (đang có lỗi bên BE). */
    this.settlePrintGate(true);
    try {
      await this.props.setConfirmAssistedPaymentCskh(
        confirmCashierBookingData.booking,
        confirmCashierBookingData?.transactionId
      );

      if (confirmCashierBookingData?.transactionId) {
        /* Load lại phiếu với mã transactionId mới từ Cashier Booking */
        history.push(
          window.location.pathname +
            `?mpTransaction=${confirmCashierBookingData?.transactionId}`
        );

        setTimeout(() => {
          this.props.requestPaymentInfoCSKH({
            transactionId: confirmCashierBookingData?.transactionId
          });
        }, 100);
      }
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      this.toggleModalConfirmCashierBooking();
    }
  };

  onCreateCashierBooking = async bookingInfo => {
    /* Khởi tạo đơn thu tiền mặt */
    this.setState({ confirmCashierBookingLoading: true });
    try {
      const { data } = await client.createCashierBooking({
        bookingId: bookingInfo?._id
      });
      this.setState({
        confirmCashierBookingData: data,
        isConfirmCashierBooking: true
      });
      return true;
    } catch (error) {
      console.error("onCreateCashierBooking error :>> ", error);
      openToast("Khởi tạo phiếu thu không thành công", "error");
      return false;
    } finally {
      this.setState({ confirmCashierBookingLoading: false });
    }
  };

  toggleModalCare247Pay = () => {
    this.setState({
      modalCare247Pay: !this.state.modalCare247Pay
    });
  };

  fetchCare247Pay = billInfo => {
    return new Promise((resolve, reject) => {
      this.setState({
        loadingCare247Pay: true
      });
      this.props.setCare247Independent(
        billInfo._id,
        billInfo?.care247ServiceId,
        this.props.dataCheckVoucherCare247,
        "cancel",
        () => {
          this.setState({
            loadingCare247Pay: false
          });
          resolve();
        },
        error => {
          console.log("error :>> ", error);
          this.setState({
            loadingCare247Pay: false
          });
          resolve(); // Resolve instead of reject so it doesn't throw unhandled promise rejection if not caught, but error is handled.
        }
      );
    });
  };

  fetchCare247Voucher = async voucher => {
    try {
      this.props.checkVoucherCare247({
        code: voucher
      });
    } catch (error) {
      console.log("error :>> ", error);
      openToast(
        `${error.response.data.message || "Đã có lỗi xảy ra"}`,
        "error"
      );
    }
  };

  fetchCare247Services = async billInfo => {
    try {
      this.setState({
        loadingCare247Pay: true
      });
      const requestBody = { ...billInfo, independentCare247: true };
      this.props.getCare247Services(requestBody);
      this.props.setCare247IndependentReset();
      this.props.checkVoucherCare247Reset();

      this.toggleModalCare247Pay();
    } catch (error) {
      console.log("error :>> ", error);
    } finally {
      this.setState({
        loadingCare247Pay: false
      });
    }
  };

  render() {
    const { paymentInformation, partnerId } = this.props;
    const {
      billPrint,
      loading,
      activeItemBooking,
      confirmCashierBookingLoading,
      isConfirmCashierBooking,
      confirmCashierBookingData,
      modalCare247Pay,
      loadingCare247Pay
    } = this.state;
    const {
      dataIndependent,
      loadingTicket,
      dataCare247Services,
      loadingCare247Service,
      dataCheckVoucherCare247,
      loadingCheckVoucherCare247,
      errorCheckVoucherCare247
    } = this.props;

    const checkDateValid = billInfo => {
      const { date } = billInfo;
      const ngayKham = moment(date);
      const ngayHienTai = moment();
      return moment(ngayHienTai).isBefore(ngayKham);
    };
    const medproCare = get(first(paymentInformation), "bookingInfo.medproCare");
    const bookingInfo = get(first(paymentInformation), "bookingInfo");
    const partner = get(first(paymentInformation), "partner");
    const patient = get(first(paymentInformation), "patient");
    const showMedproCare = !isEmpty(medproCare);
    if (loading) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }
    return (
      <div className={styles.wrapper_bill}>
        <div className={styles.groupBtn}>
          {/* Nút gửi phiếu khám */}
          {/* Nút thanh toán Care247 */}
          {bookingInfo?.canPayCare247 && checkDateValid(bookingInfo) && (
            <MDBBtn
              color="primary"
              size="sm"
              onClick={async () => {
                await this.fetchCare247Services(bookingInfo);
              }}
            >
              Thanh toán Care247
            </MDBBtn>
          )}
          {!billPrint && !partner?.newHospitalTypes?.includes(8) && (
            <MDBBtn
              color="success"
              size="sm"
              onClick={() => {
                this.toggleModalSendBooking(first(paymentInformation));
              }}
            >
              Gửi phiếu khám
            </MDBBtn>
          )}

          {/* Nút lấy phiếu in hoặc in phiếu (Không hiện cho UMC) */}
          {!["umc"].includes(partnerId) &&
            (!billPrint ? (
              <MDBBtn color="primary" size="sm" onClick={this.handleChangeBill}>
                Lấy phiếu in
              </MDBBtn>
            ) : (
              <ReactToPrint
                ref={el => (this.usePrintRef = el)}
                trigger={() => (
                  <MDBBtn color="primary" size="sm">
                    In phiếu khám
                  </MDBBtn>
                )}
                onBeforeGetContent={this.handleBeforePrint}
                onAfterPrint={this.handleChangeBill}
                content={() => this.componentRef}
                pageStyle="print"
                onPrintError={(location, error) => {
                  if (!error?.isPrintAborted) {
                    openToast("In phiếu thất bại :>> ");
                  }
                }}
                suppressErrors
              />
            ))}

          {/* Nút xác nhận thu tiền cho Cashier Booking */}
          {bookingInfo?.isCashierBooking && (
            <MDBBtn
              disabled={
                bookingInfo?.confirmCashierBooking ||
                confirmCashierBookingLoading
              }
              color="green"
              size="sm"
              onClick={() => this.onCreateCashierBooking(bookingInfo)}
            >
              Xác nhận đã thu tiền mặt tại quầy
            </MDBBtn>
          )}
        </div>

        {billPrint ? (
          <>
            <div
              className={styles.printer}
              ref={el => (this.componentRef = el)}
            >
              <MedicalBillPrinter type="CSKH" />
            </div>
          </>
        ) : (
          <div className={styles.BookingCoupon}>
            {showMedproCare && (
              <>
                <MDBNav className={cx(styles.tabsBooking)}>
                  <MDBNavItem
                    className={cx(
                      activeItemBooking === "NormalMedpro"
                        ? styles.NormalMedpro
                        : ""
                    )}
                    active={activeItemBooking === "NormalMedpro"}
                    onClick={() => this.toggleTabs("NormalMedpro")}
                  >
                    <span>Phiếu khám</span>
                  </MDBNavItem>
                  <MDBNavItem
                    className={cx(
                      activeItemBooking === "MedproCare"
                        ? styles.MedproCare
                        : ""
                    )}
                    active={activeItemBooking === "MedproCare"}
                    onClick={() => this.toggleTabs("MedproCare")}
                  >
                    <span>Dịch vụ Care247</span>
                  </MDBNavItem>
                </MDBNav>
              </>
            )}
            <MDBTabContent activeItem={activeItemBooking}>
              <MDBTabPane tabId="NormalMedpro">
                <MedicalCoupon type="CSKH" />
              </MDBTabPane>
              <MDBTabPane tabId="MedproCare">
                <MedicalCouponCare {...this.props} />
              </MDBTabPane>
            </MDBTabContent>
          </div>
        )}

        <ModalSendBooking
          toggle={this.toggleModalSendBooking}
          show={this.state.showSendBookingModal}
          itemCoupon={this.state.selectingBill}
        />

        {isConfirmCashierBooking && (
          <ModalConfirmCashierBooking
            isOpen={isConfirmCashierBooking}
            toggle={this.handleCancelCashierModal}
            patient={patient}
            data={confirmCashierBookingData}
            confirmAction={this.fetchConfirmAssistedPayment}
          />
        )}

        {modalCare247Pay && (
          <ModalCare247Pay
            billInfo={bookingInfo}
            loadingCare247Pay={loadingCare247Pay}
            loadingTicket={loadingTicket}
            loadingCare247Service={loadingCare247Service}
            dataIndependent={dataIndependent}
            dataCare247Services={dataCare247Services}
            dataCheckVoucherCare247={dataCheckVoucherCare247}
            loadingCheckVoucherCare247={loadingCheckVoucherCare247}
            errorCheckVoucherCare247={errorCheckVoucherCare247}
            isOpen={modalCare247Pay}
            toggle={this.toggleModalCare247Pay}
            onClose={this.toggleModalCare247Pay}
            fetchCare247Pay={this.fetchCare247Pay}
            onApplyVoucher={async (pkg, voucher) => {
              await this.fetchCare247Voucher(voucher);
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    totalData: { paymentInformation, partnerId },
    customerService: {
      selectedBill,
      selectedPatient,
      dataIndependent,
      loadingTicket,
      dataCare247Services,
      loadingCare247Service,
      dataCheckVoucherCare247,
      loadingCheckVoucherCare247,
      errorCheckVoucherCare247
    }
  } = state;
  return {
    selectedBill,
    selectedPatient,
    partnerId,
    paymentInformation,
    dataIndependent,
    loadingTicket,
    dataCare247Services,
    loadingCare247Service,
    dataCheckVoucherCare247,
    loadingCheckVoucherCare247,
    errorCheckVoucherCare247
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps
});

export default connect(
  mapStateToProps,
  {
    requestPaymentInfoCSKH,
    checkRepayment,
    setPaymentInfomationByCSKH,
    getBookingInfo,
    redirectToMedproId,
    selectPatientFromData,
    setConfirmAssistedPaymentCskh: (bookingId, transactionId) =>
      getConfirmAssistedPaymentCskh(bookingId, transactionId),
    resetPatientForm,
    handleSelectedPatient: selectedPatientDetail,
    handleGetPatientDetail: getPatientDetail,
    getCare247Services: payload => getCare247Services(payload),
    setCare247Independent: (
      bookingId,
      care247ServiceId,
      voucher,
      actionType,
      onSuccess,
      onError
    ) =>
      getCare247IndependentCSKH(
        bookingId,
        care247ServiceId,
        voucher,
        actionType,
        onSuccess,
        onError
      ),
    checkVoucherCare247: voucher => checkVoucherCare247(voucher),
    setCare247IndependentReset: () => getCare247IndependentCSKHReset(),
    checkVoucherCare247Reset: () => checkVoucherCare247Reset()
  },
  mergeProps
)(MedicalBillPrintForCSKH);
